import React, { Component } from "react";

const get$ = () =>
  typeof window !== "undefined" && (window.$ || window.jQuery)
    ? (window.$ || window.jQuery)
    : null;

class SaleService extends Component {
  state = {
    serviceType: "ALL",
    region: "ALL",
    city: "ALL",
  };

  selRefs = {
    serviceType: React.createRef(),
    region: React.createRef(),
    city: React.createRef(),
  };

  // --- Nice Select yardımcıları ---
  bindReactSync = (name) => {
    const $ = get$();
    const ref = this.selRefs[name]?.current;
    if (!$ || !ref) return;
    $(ref).off("change._reactSync").on("change._reactSync", (evt) => {
      this.handleChange(evt);
    });
  };

  // Aynı select için var olan nice-select wrapper'larını temizle
  cleanupNiceSelect = (name) => {
    const $ = get$();
    const ref = this.selRefs[name]?.current;
    if (!$ || !ref) return;
    const $sel = $(ref);

    // En yaygın yapı: <select> hemen sonrasında .nice-select kardeşi
    $sel.next(".nice-select").remove();

    // Bazı temalarda wrapper aynı container içinde olabilir
    $sel.parent().children(".nice-select").not($sel).remove();

    // Seçili select gizli kalmışsa görülebilir yap
    $sel.show();
  };

  initNiceSelect = (name) => {
    const $ = get$();
    const ref = this.selRefs[name]?.current;
    if (!$ || !ref) return;

    const $sel = $(ref);
    // Her ihtimale karşı önce eski wrapper'ları temizle
    this.cleanupNiceSelect(name);

    // Artık tek bir select var → init et
    $sel.niceSelect();
    this.bindReactSync(name);
  };

  updateNiceSelect = (name) => {
    const $ = get$();
    const ref = this.selRefs[name]?.current;
    if (!$ || !ref) return;

    const $sel = $(ref);
    if ($sel.next(".nice-select").length) {
      $sel.niceSelect("update");
    } else {
      // wrapper yoksa temiz init
      this.initNiceSelect(name);
    }
  };

  rebuildNiceSelect = (name) => {
    // Tam temiz kurulum
    this.cleanupNiceSelect(name);
    this.initNiceSelect(name);
  };

  destroyNiceSelect = (name) => {
    const $ = get$();
    const ref = this.selRefs[name]?.current;
    if (!$ || !ref) return;

    const $sel = $(ref);
    $sel.off("change._reactSync");
    if ($sel.next(".nice-select").length) {
      $sel.niceSelect("destroy");
    }
    // Yine de kalmış wrapper varsa temizle
    $sel.next(".nice-select").remove();
    $sel.parent().children(".nice-select").not($sel).remove();
  };
  // --- /Nice Select ---

  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "region" || name === "serviceType") {
      this.setState({ [name]: value, city: "ALL" });
    } else {
      this.setState({ [name]: value });
    }
  };

  normalizeStr = (s) => (typeof s === "string" ? s.trim() : s);

  getFilteredData = (list, { skipCity = false, stateOverride } = {}) => {
    const base = stateOverride || this.state;
    const { serviceType, region, city } = base;

    return (list || [])
      .filter((item) => !!item?.status)
      .filter((item) => {
        if (serviceType === "SALES") return !!item.offersSales;
        if (serviceType === "SERVICE") return !!item.offersService;
        return true;
      })
      .filter((item) => {
        if (region === "DOMESTIC") return item.isDomestic === true;
        if (region === "ABROAD") return item.isDomestic === false;
        return true;
      })
      .filter((item) => {
        if (skipCity || city === "ALL") return true;
        return this.normalizeStr(item.city) === city;
      });
  };

  getCityOptions = (list, stateOverride) => {
    const filteredForCities = this.getFilteredData(list, {
      skipCity: true,
      stateOverride,
    });
    const set = new Set(
      filteredForCities.map((x) => this.normalizeStr(x.city)).filter(Boolean)
    );
    return Array.from(set).sort((a, b) => a.localeCompare(b, "tr"));
  };

  componentDidMount() {
    // İlk init (önce temizlik)
    ["serviceType", "region", "city"].forEach((n) => {
      this.cleanupNiceSelect(n);
      this.initNiceSelect(n);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // Value değişimleri
    if (prevState.serviceType !== this.state.serviceType) {
      this.updateNiceSelect("serviceType");
    }
    if (prevState.region !== this.state.region) {
      this.updateNiceSelect("region");
    }
    if (prevState.city !== this.state.city) {
      this.updateNiceSelect("city");
    }

    // Şehir opsiyonları değişti mi? → rebuild
    const prevSvc = prevProps?.serviceRegion?.serviceRegions || [];
    const currSvc = this.props?.serviceRegion?.serviceRegions || [];
    const prevCities = this.getCityOptions(prevSvc, prevState);
    const currCities = this.getCityOptions(currSvc, this.state);

    const citiesChanged =
      prevCities.length !== currCities.length ||
      prevCities.join("|") !== currCities.join("|");

    if (citiesChanged) {
      this.rebuildNiceSelect("city");
      if (this.state.city !== "ALL" && !currCities.includes(this.state.city)) {
        this.setState({ city: "ALL" }, () => this.updateNiceSelect("city"));
      }
    }
  }

  componentWillUnmount() {
    ["serviceType", "region", "city"].forEach(this.destroyNiceSelect);
  }

  render() {
    const { serviceRegion, serviceRegionPageConfig, loading } = this.props;
    const { serviceType, region, city } = this.state;

    const serviceRegions = serviceRegion?.serviceRegions || [];
    const cityOptions = this.getCityOptions(serviceRegions);
    const filtered = this.getFilteredData(serviceRegions);
    const config = serviceRegionPageConfig || {};
    return (
      <div className="liton__wishlist-area pb-70" style={{ marginTop: -50 }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__product-tab-area">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="ltn__myaccount-tab-content-inner">
                        <div className="row">
                          {/* Hizmet Seçiniz */}
                          <div className="col-12 col-md-4">
                            <div className="car-dealer-form-inner">
                              <h6>Hizmet Seçiniz</h6>
                              <div className="ltn__car-dealer-form-item ltn__custom-icon---- ltn__icon-car----">
                                <select
                                  ref={this.selRefs.serviceType}
                                  className="w-100"
                                  name="serviceType"
                                  value={serviceType}
                                  onChange={this.handleChange}
                                >
                                  <option value="ALL">Tümü</option>
                                  <option value="SALES">Satış Noktaları</option>
                                  <option value="SERVICE">Servis Noktaları</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {/* Bölge Seçiniz */}
                          <div className="col-12 col-md-4">
                            <div className="car-dealer-form-inner">
                              <h6>{config.regionText || "Bölge Seçiniz"}</h6>
                              <div className="ltn__car-dealer-form-item ltn__custom-icon---- ltn__icon-car----">
                                <select
                                  ref={this.selRefs.region}
                                  className="w-100"
                                  name="region"
                                  value={region}
                                  onChange={this.handleChange}
                                >
                                  <option value="ALL">Tümü</option>
                                  <option value="DOMESTIC">Yurt İçi</option>
                                  <option value="ABROAD">Yurt Dışı</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {/* İl Seçiniz */}
                          <div className="col-12 col-md-4">
                            <div className="car-dealer-form-inner">
                              <h6>{config.cityText || "İl Seçiniz"}</h6>
                              <div className="ltn__car-dealer-form-item ltn__custom-icon---- ltn__icon-car----">
                                <select
                                  ref={this.selRefs.city}
                                  className="w-100"
                                  name="city"
                                  value={city}
                                  onChange={this.handleChange}
                                >
                                  <option value="ALL">Tümü</option>
                                  {cityOptions.map((c) => (
                                    <option key={c} value={c}>
                                      {c}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <hr style={{ margin: "20px 0" }} />

                        {/* Tablo */}
                        <div className="row">
                          <div className="col-12">
                            {loading ? (
                              <div className="py-4">Yükleniyor...</div>
                            ) : filtered.length === 0 ? (
                              <div className="py-4">Kayıt bulunamadı.</div>
                            ) : (
                              <table className="bayi-table animated fadeIn">
                                <thead>
                                  <tr>
                                    <th>Satış &amp; Servis</th>
                                    <th>Yönetici</th>
                                    <th>Email</th>
                                    <th>Telefon</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {filtered.map((item) => (
                                    <tr key={item.id}>
                                      <td>
                                        <div className="d-flex">
                                          <span>{item.title}</span>
                                          <div style={{ marginLeft: 10, fontSize: 12 }}>
                                            {item.offersSales && (
                                              <span className="badge bg-success me-1">Satış</span>
                                            )}
                                            {item.offersService && (
                                              <span className="badge bg-info">Servis</span>
                                            )}
                                          </div>
                                        </div>
                                        {item.address}
                                        <br />
                                      </td>
                                      <td>{item.name || "-"}</td>
                                      <td>{item.email && item.email !== "-" ? item.email : "-"}</td>
                                      <td>{item.phone || "-"}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SaleService;
